import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "es", "fr", "zh"],
  defaultLocale: "en",
  // English has no prefix: /history-of-astrology
  // Others prefixed:       /es/historia-de-la-astrologia
  localePrefix: "as-needed",
});

export type Locale = (typeof routing.locales)[number];
